import { dbAdd, dbDelete, dbGetAll, dbGetById, dbPut } from '../indexedDb.ts';

export interface LocalInvestmentGoal {
  id: number;
  name: string;
  target_amount: number;
  target_date: string;
  priority: number;
  plan_id?: number;
  created_at: string;
  updated_at?: string;
  server_id?: number;
  last_synced_at?: string;
  needs_sync?: boolean;
}

export function listInvestmentGoals() {
  return dbGetAll<LocalInvestmentGoal>('investment_goals');
}

export function getInvestmentGoalById(id: number) {
  return dbGetById<LocalInvestmentGoal>('investment_goals', id);
}

export async function getInvestmentGoalByServerId(serverId: number) {
  const all = await listInvestmentGoals();
  return all.find((goal) => goal.server_id === serverId);
}

export async function createInvestmentGoal(
  data: Omit<LocalInvestmentGoal, 'id' | 'created_at' | 'updated_at' | 'server_id' | 'last_synced_at' | 'needs_sync'>
) {
  const now = new Date().toISOString();
  return dbAdd('investment_goals', { ...data, created_at: now, needs_sync: true } as any);
}

export async function updateInvestmentGoal(id: number, data: Partial<LocalInvestmentGoal>) {
  const current = await dbGetById<LocalInvestmentGoal>('investment_goals', id);
  if (!current) throw new Error('Goal not found');
  const updated = {
    ...current,
    ...data,
    id,
    updated_at: data.updated_at ?? new Date().toISOString(),
    needs_sync: data.needs_sync ?? true,
  };
  await dbPut('investment_goals', updated);
  return updated;
}

export function removeInvestmentGoal(id: number) {
  return dbDelete('investment_goals', id);
}

export async function markInvestmentGoalSynced(id: number, serverId: number) {
  const current = await dbGetById<LocalInvestmentGoal>('investment_goals', id);
  if (!current) throw new Error('Goal not found');
  current.server_id = serverId;
  current.last_synced_at = new Date().toISOString();
  current.needs_sync = false;
  await dbPut('investment_goals', current);
  return current;
}
